<template>
  <div>
    <slot name="custom-toolbar"></slot>
    <slot name="content"></slot>
  </div>
</template>

<script>
  import _Quill from 'quill';

  const Quill = _Quill;

  var Block = Quill.import('blots/block');
  Block.tagName = 'DIV';
  Quill.register(Block, true);

  export default {
    props: {
      placeholder: {
        type: String,
        default: ''
      },

      toolbar: {
        type: Array,
        default: () => []
      },

      options: {
        type: Object,
        default: () => ({})
      }
    },

    data: () => ({
      quill: null
    }),

    mounted() {
      let customToolbar = this.$slots['custom-toolbar'];
      let customToolbarHTML = customToolbar ? customToolbar[0].elm : false;
      let quillCustomToolbarId = 'custom-quilljs-toolbar';
      if (customToolbarHTML) {
        customToolbarHTML.id = quillCustomToolbarId;
      }
      this.quill = new Quill(this.$el, this.options);

      this.quill.on('text-change', (delta, oldDelta, source) => {
        let html = this.quill.root.innerHTML;
        this.$emit('text-change', html, delta, oldDelta, source);
      });

      this.quill.on('selection_change', () => {
        this.$emit('selection_change');
      });
    }
  };
</script>
